export default {
  id: "id",
  name: "name",
  email: "email",
  password: "password",
  permissions: "permissions",
  createdAt: "created_at",
};
